<template>
  <el-row class="content">
    <el-col class="bigtitle">
      全局参数配置
    </el-col>
    <el-col class="smtitle">
      异常提醒设置
    </el-col>
    <el-col class="desc">
      <el-radio
        v-model="tiptype"
        label="1"
      >简洁模式</el-radio>
      <el-radio
        v-model="tiptype"
        label="2"
      >强制确认模式</el-radio>
      <div class="tips">
        【注意】：简洁模式：当注塑机发生异常数据的时候，给出提示框提醒，3秒钟自动消退；
        <br />
        强制模式：当注塑机发生异常数据的时候，给出强制确认框，内容实时更新，按照注塑机、警报类型等进行归类提醒。必须确认，点击确认后，直接跳转到生产管理界面。
      </div>
    </el-col>
    <el-col class="smtitle">
      早晚班时间设置
    </el-col>
    <el-col class="desc">
      <el-form
        ref="form"
        label-width="80px"
      >

        <el-form-item label="早班">
          <el-col style="width: 240px;">
            <el-time-select
              v-model="zbs"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00'
              }"
              placeholder="选择时间"
            >
            </el-time-select>
          </el-col>
          <el-col
            class="line"
            style="width: 20px;"
          >-</el-col>
          <el-col style="width: 240px;">
            <el-time-select
              v-model="zbe"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00'
              }"
              placeholder="选择时间"
            >
            </el-time-select>
          </el-col>
        </el-form-item>

        <el-form-item label="夜班">
          <el-col style="width: 240px;">
            <el-time-select
              v-model="ybs"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00'
              }"
              placeholder="选择时间"
            >
            </el-time-select>
          </el-col>
          <el-col
            class="line"
            style="width: 20px;"
          >-</el-col>
          <el-col style="width: 240px;">
            <el-time-select
              v-model="ybe"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '23:00'
              }"
              placeholder="选择时间"
            >
            </el-time-select>
          </el-col>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col>
      <el-button
        type="primary"
        style="margin-left:200px;margin-top:20px;"
        @click="saveSet"
      >修改配置</el-button>
      <div class="tips">【注意】：早夜班起始时间修改后，后续的操作立马生效，修改之前的数据按照修改之前的数据来计算</div>
    </el-col>

  </el-row>
</template>

<script>

import { getsysinfo,setsysinfo} from "../../api/api";

export default {
  data() {
    return {
      tiptype: "1",
      ybs: "",
      ybe: "",
      zbe: "",
      zbs: "",
    };
  },
  created(){
    let that = this;
    getsysinfo({}).then(res =>{

      if(res.state == 0){
        that.tiptype = res.data.tiptype;
        that.ybs = res.data.ybs;
        that.ybe = res.data.ybe;
        that.zbe = res.data.zbe;
        that.zbs = res.data.zbs;        
      }

    });
  },
  methods: {
    saveSet() {
      let that = this;

      if (that.zbs == "") {
        this.$message({
          message: "早班开始时间必须填写！",
          type: "error",
        });
        return false;
      }

      if (that.zbe == "") {
        this.$message({
          message: "早班结束时间必须填写！",
          type: "error",
        });
        return false;
      }

      if (that.ybs == "") {
        this.$message({
          message: "夜班开始时间必须填写！",
          type: "error",
        });
        return false;
      }

      if (that.ybe == "") {
        this.$message({
          message: "夜班结束时间必须填写！",
          type: "error",
        });
        return false;
      }

      if(that.ybs < that.zbe){
        this.$message({
          message: "夜班开始时间不能早于早班结束时间！",
          type: "error",
        });
        return false;
      }

      if(that.zbs < that.ybe){
        this.$message({
          message: "早班开始时间不能早于夜班结束时间！",
          type: "error",
        });
        return false;
      }
      this.$confirm("确认要修改系统默认配置信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setsysinfo({ tiptype: that.tiptype,zbs:that.zbs,zbe:that.zbe,ybs:that.ybs,ybe:that.ybe }).then((res) => {
            if (res.state == 0) {
              this.$message({
                message: "系统默认配置信息修改成功",
                type: "success",
              });
               
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.content {
  background: #fff;
  padding: 20px;
}

.content > .bigtitle {
  font-size: 24px;
  color: #4bc0de;
  margin-bottom: 10px;
}

.content > .smtitle {
  font-size: 18px;
  color: #4bc0de;
}

.desc {
  padding: 20px;
}

.tips {
  color: #f56c6c;
  width: 550px;
  margin-top: 10px;
}
</style>